import { LicenseTypeNature } from '../../../types';

const tabIndexes = {
  HEADER: 0,
  NAMES_AND_PARTIES: 1,
  ITEMS: 2,
  ATTACHED_DOCUMENTS: 3,
  FEES: 4,
  CONSIGNMENT: null,
};

const tabIndexesWithConsignment = {
  HEADER: 0,
  NAMES_AND_PARTIES: 1,
  CONSIGNMENT: 2,
  ITEMS: 3,
  ATTACHED_DOCUMENTS: 4,
  FEES: 5,
};

export function getTabIndexes(licenseTypeNature?: LicenseTypeNature) {
  if (licenseTypeNature === LicenseTypeNature.EPHYTO) {
    return tabIndexesWithConsignment;
  }

  return tabIndexes;
}
